module.exports = __webpack_public_path__ + "assets/img/Pei Tong Primary School.11ec8498.jpg";